import localforage from "localforage";
import firebase from "firebase";

localforage.config({
  name: "flamelink",
  storeName: "flamelink_store", // Should be alphanumeric, with underscores.
  driver: [localforage.INDEXEDDB, localforage.WEBSQL, localforage.LOCALSTORAGE],
  version: 1, // Needs to be a number, string will crash indexedDB `open`
  size: 52428800, // 50MB only used for WebSQL fallback
  description: "Browser persistence of Flamelink app data",
});

export const localForage = localforage;

export const timeZoneDate = (d) => {
  let date = d || new Date();
  return new Date(
    date.getTime() - date.getTimezoneOffset() * 60000
  ).toISOString();
};

export const isGuest = () => {
  const { email } = firebase.auth().currentUser;
  return ["brandon@socialmediashopza.com"].includes(email);
};
